// -------------------------------------------
// PLaceholder data
// -------------------------------------------
import { SCENARIO_TYPES, DOCUMENT_TYPES, SCORE_METRIC_TYPES } from 'game/constants/Constants';

export const placeholderScenarioData = [
  {
    title: 'There has been a case of a lea',
    id: 1,
    type: SCENARIO_TYPES.EMAIL,
    documents: {
      0: {
        title: 'Re: Negotiation Tactics',
        id: 1,
        type: DOCUMENT_TYPES.EMAIL,
        body: {
          line_1: 'Sam,',
          line_2:
            'It’s come to my attention that there may be a chink in the armour of the other side. Intelligence has revealed we might have some leverage if you infer that we know certain details (document attached) about the other country’s human rights record. Particularly the exploits of their military in the redacted conflict.',
          line_3: 'Keep me updated.',
          line_4: 'Regards,',
          line_5: 'The Right Honourable Linda Richardson',
        },
      },
      1: {
        title: '',
        id: 2,
        type: DOCUMENT_TYPES.DOCUMENT,
        body: {
          line_1: 'Anonymous user / Home nation / Social Media',
          line_2:
            'This is disgusting! These people are acting like spies not negotiators. We should treat the other country with respect not suspicion. Typical!',
          line_3: 'Anonymous user / Opposition nation / Social Media',
          line_4:
            "It shows they're not taking us seriously or viewing us as an equal sovereign nation. We should pull out with no deal.",
        },
      },
      2: {
        title: '',
        id: 3,
        type: DOCUMENT_TYPES.MESSAGE,
        body: {
          line_1:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam imperdiet facilisis finibus. Duis vitae enim pulvinar, ultrices elit sit amet, lobortis urna. Donec posuere euismod viverra. Cras scelerisque hendrerit aliquam. Praesent dapibus non diam eget feugiat. Praesent semper eleifend enim. Cras non quam nunc. Suspendisse et tellus at odio pharetra luctus.',
          line_2:
            'Pellentesque pulvinar, quam eget tincidunt finibus, tellus erat blandit ipsum, eget rhoncus diam massa ac diam. Duis porttitor at quam sit amet vulputate. Morbi a rhoncus est. In ac tortor eget lectus placerat consectetur non eget neque. Mauris facilisis nisi enim, quis vestibulum erat pellentesque hendrerit. Nunc quis porttitor.',
        },
      },
    },
    outcomes: {
      card: {
        type: SCENARIO_TYPES.EMAIL,
        desc: 'A sensitive email is leaked to the media, revealing confidential communications between you and your Defence Secretary.',
      },
      option_a: {
        id: 1,
        type: 'option',
        desc: 'Acknowledge the leak and do your best to reassure your opponent.',
        scores: [
          {
            type: SCORE_METRIC_TYPES.CREDIBILITY,
            value: 10,
          },
          {
            type: SCORE_METRIC_TYPES.NEGOTIATION,
            value: 5,
          },
        ],
        result: {
          title: 'Honesty is the best policy',
          desc: 'Your openness and honesty score you a few points with your opponent, but you can’t help but lose credibility based on the content of the leaked document.',
        },
      },
      option_b: {
        id: 2,
        type: 'option',
        desc: 'Deny the veracity of leak and try and brush it under the carpet.',
        scores: [
          {
            type: SCORE_METRIC_TYPES.CREDIBILITY,
            value: -20,
          },
          {
            type: SCORE_METRIC_TYPES.PUBLIC_OPINION,
            value: 10,
          },
        ],
        result: {
          title: "You're in denial",
          desc: 'Your denial comes across as political bluster, and you lose both credibility and public goodwill in the face of undeniable evidence.',
        },
      },
    },
  },
];
